<ind-section-header *ngIf="timelineSectionHeader" [viewData]='timelineSectionHeader' (onControlClick)='onSectionHeaderControlClick($event)'></ind-section-header>

<!--Timeline/Journey Section-->  
<ion-list class="time-line-list" *ngIf="!isDataLoading">
  <timeline-item *ngFor="let item of timelineItems; trackBy: trackById" [inputData]="item" (clickedOnHeader)="openDetails($event)"></timeline-item>
</ion-list>
<ion-list *ngIf="timelineItems && timelineItems.length == 0 && !isDataLoading">
  <div class="no-data-message" >
    {{'NO_ACTIVITIES_CAP' | translate}}
  </div>
</ion-list>

<ng-container *ngIf="isDataLoading">
  <ng-container *ngFor="let item of [1, 2, 3]; let last = last; trackBy: trackByIndex">
    <!-- Skeleton Item -->
    <div>
      <!-- Top title and timestamp -->
      <ion-item lines="none">
        <ion-label>
          <ion-skeleton-text animated style="width: 60%; height: 16px;" class="skeleton-text-animated"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 30%; height: 12px; margin-top: 6px;" class="skeleton-text-animated"></ion-skeleton-text>
        </ion-label>
      </ion-item>

      <!-- Grid layout -->
      <ion-grid class="ion-padding-start ion-padding-end" style="margin-top: 12px;">
        <ion-row>
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 80%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 100%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
        </ion-row>

        <ion-row style="margin-top: 10px;">
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 60%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 50%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
        </ion-row>

        <ion-row style="margin-top: 10px;">
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 70%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
          <ion-col size="6">
            <ion-skeleton-text animated style="width: 60%; height: 14px;" class="skeleton-text-animated"></ion-skeleton-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="separationLine"></div>

  </ng-container>
</ng-container>